import Axios from "@/utils/axios/Axios";
import ENV from "@/utils/constants/environment";
import Pagination from "@/model/Pagination";

const RESOURCE_NAME = "file";
const RESOURCE_HELP_FILES = "file/help";

export default {
  HELP_FOLDER: "help",
  /** File mime type defaults to PDF **/
  getFileFromNameAndFolder(name: string, folder: string) {
    return Axios("blob").get(
      ENV.API_URL + RESOURCE_NAME + `?name=${name}&folder=${folder}`
    );
  },

  /* Obtiene la lista de archivos de ayuda */
  getHelpFiles(pagination: Pagination, params: any) {
    return Axios().get(ENV.API_URL + RESOURCE_HELP_FILES, {
      params: {
        page: pagination.page,
        size: pagination.size,
        sort: pagination.sort,
        search: params.search
      }
    });
  },
  getAllHelpFiles() {
    return Axios().get(ENV.API_URL + RESOURCE_HELP_FILES);
  },
  saveHelpFile(form: any, header: any) {
    return Axios().post(ENV.API_URL + RESOURCE_HELP_FILES, form, header); //{ headers: {Authorization: `Bearer ${jwt}`} }); --> Header con autorización 'Bearer Token'
  },
  updateHelpFile(id: number, form: any, header: any) {
    return Axios().put(
      ENV.API_URL + RESOURCE_HELP_FILES + `/${id}`,
      form,
      header
    );
  },
  deleteHelpFile(id: number) {
    return Axios().delete(ENV.API_URL + RESOURCE_HELP_FILES + `/${id}`);
  },
  downloadHelpFile(id: number) {
    return Axios("blob").get(ENV.API_URL + RESOURCE_HELP_FILES + `/${id}`);
  },
  findAll(pagination: Pagination, params: any) {
    return Axios().get(ENV.API_URL + RESOURCE_NAME, {
      params: {
        page: pagination.page,
        size: pagination.size,
        sort: pagination.sort,
        search: params.search,
        active: params.active
      }
    });
  },

};
